import { render, staticRenderFns } from "./TechEarth.vue?vue&type=template&id=7554a8ae&scoped=true"
import script from "./TechEarth.vue?vue&type=script&setup=true&lang=js"
export * from "./TechEarth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TechEarth.vue?vue&type=style&index=0&id=7554a8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7554a8ae",
  null
  
)

export default component.exports